import type { RouteRecordRaw } from 'vue-router'

export const ROUTES = {
  AUTH: {
    LOGIN: 'auth/login',
    LOGOUT: 'auth/logout',
  },
}

const routes: RouteRecordRaw[] = [
  {
    component: () => import('./pages/Login/Login.vue'),
    name: ROUTES.AUTH.LOGIN,
    path: '/auth/login',
    meta: {
      // The authentication flow takes place in two steps. First, we start the
      // flow and get redirected to the Identity stack. Second, we come back
      // from the Identity stack, and we retrieve actual authentication tokens.
      //
      // In the context of the migration, it means that the flow might start
      // from Front Office, and then ends up on Pastrami. However, while being
      // very similar, both implementations are not completely compatible.
      // So, we must ensure that the whole flow both starts and ends on the
      // same application.
      //
      // While Pastrami serves at least one page where we can authenticate
      // from (including links in the header), we can't use the Front Office
      // implementation, and thus must force a redirection to Pastrami.
      disableClientSideNavigation: () => true,
    },
  },
]

export default routes
